import { InfoBoxProps } from "./interface";
import { handler } from "./handlers";
import { InfoBoxDiv } from "./Styled";

export default function InfoBox({
  risk,
  rows,
  isClickable,
  handleAbove,
  handleNotification,
  audio,
}: InfoBoxProps) {
  const handleClick = () =>
    handler(isClickable, handleAbove, handleNotification, audio);

  return (
    <InfoBoxDiv
      data-testid="infoBoxDiv"
      onClick={handleClick}
      isClickable={isClickable}
    >
      <h2>
        <span>RISK </span>
        {risk}
        <span> ROWS </span>
        {rows}
      </h2>
    </InfoBoxDiv>
  );
}
